export default __webpack_public_path__ + "static/media/easter_egg.deacb52d.svg";